import { FormBuilderData } from 'components/shared/form/FormBuilder/types';
import { ConditionalLink } from 'components/public/dashboard/surveyPages';
import { createDefaultEngagement, Engagement, Status } from './engagement';
import { SubmissionStatus } from 'constants/engagementStatus';

export interface SurveyLookup {
    id: number;
    name: string;
}

export interface Survey {
    id: number;
    name: string;
    responseCount: number;
    created_date: string;
    is_hidden: boolean;
    is_template: boolean;
    engagement?: Engagement;
    form_json?: FormBuilderData;
    comments?: unknown;
    comments_meta_data: SurveyCommentData;
    engagement_id: number;
    engagement_status_id?: number;
    // Each conditionally-shown follow-up question keyed to the question that triggers it. Derived
    // from form_json by the API, and unlike the dashboard's copy it covers every question whatever
    // state the engagement is in.
    conditional_links?: Record<string, ConditionalLink>;
}

export interface SurveyListItemEngagement {
    id: number;
    name: string;
    published_date: string | null;
    engagement_status: Status;
    submission_status: SubmissionStatus;
}

// What GET /surveys/ actually returns for an ordinary list.
export type SurveyListItem = Omit<Survey, 'form_json' | 'engagement'> & {
    engagement?: SurveyListItemEngagement;
};

export interface SurveyCommentData {
    total: number;
    pending: number;
    approved: number;
    rejected: number;
    needs_further_review: number;
}

export interface SurveySubmissionData {
    total: number;
    approved: number;
    rejected: number;
    pending: number;
    needs_further_review: number;
}

export const createDefaultSurvey = (): Survey => {
    return {
        id: 0,
        name: '',
        responseCount: 0,
        created_date: '',
        is_hidden: false,
        is_template: false,
        engagement: createDefaultEngagement(),
        comments_meta_data: {
            total: 0,
            pending: 0,
            approved: 0,
            rejected: 0,
            needs_further_review: 0,
        },
        engagement_id: 0,
    };
};
